import {
  Facebook,
  Heading1,
  Heading2,
  Heading3,
  Image,
  Instagram,
  Link,
  List,
  Minus,
  Music,
  Quote,
  Table,
  Twitter,
  Video,
  Youtube,
} from 'lucide-react'
import { Group } from './types.js'
import i18next from 'i18next'

export const GROUPS: Group[] = [
  {
    name: 'format',
    title: i18next.t('format') || 'Format',
    commands: [
      {
        name: 'heading1',
        label: i18next.t('heading1') || 'Heading 1',
        description: i18next.t('heading1Desc') || 'High priority section title',
        icon: Heading1,
        aliases: ['h1'],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 1 }).run()
        },
      },
      {
        name: 'heading2',
        label: i18next.t('heading2') || 'Heading 2',
        description: i18next.t('heading2Desc') || 'Medium priority section title',
        icon: Heading2,
        aliases: ['h2'],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 2 }).run()
        },
      },
      {
        name: 'heading3',
        label: i18next.t('heading3') || 'Heading 3',
        description: i18next.t('heading3Desc') || 'Low priority section title',
        icon: Heading3,
        aliases: ['h3'],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 3 }).run()
        },
      },
      {
        name: 'bulletList',
        label: i18next.t('bulletList') || 'Bullet List',
        description: i18next.t('bulletListDesc') || 'Unordered list of items',
        icon: List,
        aliases: ['ul'],
        action: (editor) => {
          editor.chain().focus().toggleBulletList().run()
        },
      },
      {
        name: 'blockquote',
        label: i18next.t('blockquote') || 'Blockquote',
        description: i18next.t('blockquoteDesc') || 'Element for quoting',
        icon: Quote,
        action: (editor) => {
          editor.chain().focus().setBlockquote().run()
        },
      },
    ],
  },
  {
    name: 'insert',
    title: 'Insert',
    commands: [
      {
        name: 'image',
        label: i18next.t('image') || 'Image',
        description: i18next.t('imageDesc') || 'Insert an image',
        icon: Image,
        aliases: ['img'],
        action: (editor) => {
          editor.chain().focus().setImageUpload('image').run()
        },
      },
      {
        name: 'video',
        label: i18next.t('video') || 'Video',
        description: i18next.t('videoDesc') || 'Insert a video',
        icon: Video,
        aliases: ['video'],
        action: (editor) => {
          editor.chain().focus().setImageUpload('video').run()
        },
      },
      {
        name: 'horizontalRule',
        label: i18next.t('horizontalRule') || 'HorizontalRule',
        description: i18next.t('horizontalRuleDesc') || 'Insert a horizontal divider',
        icon: Minus,
        aliases: ['hr'],
        action: (editor) => {
          editor.chain().focus().setHorizontalRule().run()
        },
      },
      {
        name: 'table',
        label: i18next.t('table') || 'Table',
        description: i18next.t('tableDesc') || 'Insert a table',
        icon: Table,
        aliases: ['table'],
        action: (editor) => {
          editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
        },
      },
    ],
  },
  {
    name: 'embed',
    title: 'Embed',
    commands: [
      {
        name: 'linkPreview',
        label: i18next.t('embed') || 'Embed Link',
        description: i18next.t('iframeDesc') || 'Insert an Embed link',
        icon: Link,
        aliases: ['linkPreview'],
        shouldBeHidden: (editor) => editor.isActive('linkPreview'),
        action: (editor) => {
          editor.chain().focus().setLinkPreview().run()
        },
      },
      {
        name: 'twitter',
        label: i18next.t('twitter') || 'Twitter',
        description: i18next.t('twitterDesc') || 'Insert a Twitter embed',
        icon: Twitter,
        aliases: ['x', 'twitter'],
        shouldBeHidden: (editor) => editor.isActive('twitter'),
        action: (editor) => {
          editor.chain().focus().insertTwitter().run()
        },
      },
      {
        name: 'facebook',
        label: i18next.t('facebook') || 'Facebook',
        description: i18next.t('facebookDesc') || 'Insert a Facebook embed',
        icon: Facebook,
        aliases: ['meta', 'facebook'],
        shouldBeHidden: (editor) => editor.isActive('facebook'),
        action: (editor) => {
          editor.chain().focus().insertFacebook().run()
        },
      },
      {
        name: 'instagram',
        label: i18next.t('instagram') || 'Instagram',
        description: i18next.t('instagramDesc') || 'Insert a Instagram embed',
        icon: Instagram,
        aliases: ['instagram'],
        shouldBeHidden: (editor) => editor.isActive('instagram'),
        action: (editor) => {
          editor.chain().focus().insertInstagram().run()
        },
      },
      {
        name: 'youtube',
        label: i18next.t('youtube') || 'Youtube',
        description: i18next.t('youtubeDesc') || 'Insert a Youtube embed',
        icon: Youtube,
        aliases: ['youtube'],
        shouldBeHidden: (editor) => editor.isActive('youtube'),
        action: (editor) => {
          editor.chain().focus().insertYoutube().run()
        },
      },
      {
        name: 'tiktok',
        label: i18next.t('tiktok') || 'Tiktok',
        description: i18next.t('tiktokDesc') || 'Insert a Tiktok embed',
        icon: Music,
        aliases: ['tiktok'],
        shouldBeHidden: (editor) => editor.isActive('tiktok'),
        action: (editor) => {
          editor.chain().focus().insertTiktok().run()
        },
      },
    ],
  },
]

export default GROUPS
